<template>
  <div class="mobile-page" :class="{ 'ios-platform': device === 'ios' }">
    <div class="iphone-icon"></div>
    <div class="des-container">
      <div class="title">Mobile Only</div>
      <div class="des">Use your mobile device to open this link:</div>
      <div class="link" @click="openMobile()">{{ linkUrl }}</div>
    </div>
  </div>
</template>
<style lang="less" scoped>
.mobile-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  &.ios-platform {
    position: relative;
    bottom: 50px;
  }
  .iphone-icon {
    background-image: url("../../../public/images/login/Rectangle@3x.png");
    width: 96px;
    height: 170px;
    background-size: contain;
  }
  .des-container {
    text-align: center;
    margin-top: 24px;
    .title {
      color: 20px;
      font-weight: 500;
    }
    .des {
      font-size: 16px;
      margin-top: 5px;
      margin-top: 15px;
    }
    .link {
      text-decoration: underline;
      font-size: 16px;
      margin-top: 30px;
      cursor: pointer;
    }
  }
}
</style>
<script>
import { getDevice } from "../../utils";
export default {
  name: "MobilePage",
  data() {
    return {
      linkUrl: process.env.VUE_APP_MOBILE_URL,
      device: "android",
    };
  },
  methods: {
    openMobile() {
      window.open(`${process.env.VUE_APP_MOBILE_URL}`, "_blank");
    },
  },
  created() {
    this.device = getDevice();
  },
};
</script>
